import { actions } from './action';

/** コンポーネントからのアクション発行はoperation経由にする(actionとviewの分離) */
export const { setImageData, setCityName, setImageMeta } = actions;
